import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { ProjectService } from '@shared/services/project.service';
import { IActivityType } from '@static/models/taskactv';

interface IExpandedActivityType extends IActivityType {
  projectName?: string;
}

@Component({
  selector: 'app-ev-group-select',
  imports: [
    MatDialogModule,
    MatSelectModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
  ],
  templateUrl: './ev-group-select.component.html',
  styleUrl: './ev-group-select.component.scss'
})
export class EvGroupSelectComponent {
  public dialogRef: MatDialogRef<EvGroupSelectComponent> = inject(MatDialogRef<EvGroupSelectComponent>);
  private _projectService: ProjectService = inject(ProjectService);

  public codeTypes: IExpandedActivityType[];
  public selectedGroup: FormControl;
  protected isPortfolio: boolean;

  constructor() {
    const pId = this._projectService.currentId;
    this.codeTypes = this._projectService.getProjectActivityCodes(pId).types;
    this.isPortfolio = this._projectService.isPortfolio();
    if (this.isPortfolio) {
      this.codeTypes.forEach(c => {
        c.projectName = this._projectService.getProjectInfo(c.proj_id)?.proj_short_name;
      });
    }
    this.selectedGroup = new FormControl();
  }

  /**
   * Get the currently selected group ID
   */
  public submit(): void {
    return this.selectedGroup.value;
  }

  /**
   * Close the dialog
   */
  close(): void {
    this.dialogRef.close(undefined);
  }
}
